// import { useEffect, useState } from "react";
// import ModalTemplate from "../../../../components/modal/modalTemplate";
// import { fetchDocument } from "../service";
// import DivSpinner from "../../../../components/divSpinner";
// import { convertTimestampToFormat } from "../../../../utils";
// import styles from "../../../approvalProcess/components/styles";
// import { theme } from "../../../../theme";
// import { useNavigate } from "react-router-dom";

// const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];

// const FileItem = ({ file }) => {
//     const fileName = file.document_file_path.split("/").pop();
//     const isImage = IMAGE_EXTENSIONS.some((ext) =>
//         fileName.toLowerCase().endsWith(ext)
//     );

//     return (
//         <div style={styles.thumb} >
//             {isImage ? (
//                 <img src={file.document_file_path} alt={file.fileName} style={styles.thumbImage} />
//             ) : (
//                 <div style={styles.pdfPreview}>
//                     <i className="material-icons" style={{ fontSize: 48 }}>
//                         file_present
//                     </i>
//                 </div>
//             )}

//             <p className="mt-2 mb-0" style={styles.fileName}>
//                 {convertTimestampToFormat(file.document_file_uploaded_at)}
//             </p>
//         </div>
//     );
// };

// const DocumentFiles = ({ show, handleClose, documentId, documentType, openNewDocumentFiles, openCurrentDocumentFiles, isHaveNewDocument, ftmId }) => {
//     const navigate = useNavigate();

//     const [document, setDocument] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [isShowNew, setIsShowNew] = useState(false);

//     useEffect(() => {
//         const getDocument = async () => {
//             try {
//                 setLoading(true);
//                 const response = await fetchDocument({
//                     document_id: documentId,
//                     document_type: documentType
//                 });

//                 if (response?.status === "Success") {
//                     setLoading(false);
//                     setDocument(response.document);
//                 }
//             } catch (error) {
//                 console.log("🚀 ~ getDocument ~ error:", error);
//             }
//         }

//         getDocument();
//     }, [documentId, documentType]);

//     const handleNewDocumentFiles = () => {
//         setIsShowNew(true);
//         openNewDocumentFiles();
//     }

//     const handleCurrentDocumentFiles = () => {
//         setIsShowNew(false);
//         openCurrentDocumentFiles();
//     }

//     return (
//         <ModalTemplate
//             show={show}
//             closeFun={handleClose}
//             centered
//             title={!loading ? document?.document_type?.document_type_name?.toUpperCase() : null}
//             backdrop="static"
//             body={
//                 <section>
//                     {loading ? (
//                         <div style={{ height: `${window.innerHeight - 387}px` }}>
//                             <DivSpinner />
//                         </div>
//                     ) : (
//                         <>
//                             {document?.document_comment && (
//                                 <div className="card mb-4" style={{ boxShadow: "unset" }}>
//                                     <div className="card-body p-3">
//                                         {document?.document_comment && (
//                                             <p>
//                                                 <b>Comment:</b>{" "}
//                                                 {document?.document_comment}
//                                             </p>
//                                         )}
//                                         {document?.document_expiry_date && (
//                                             <p className="mb-0">
//                                                 <b>Expiry date:</b>{" "}
//                                                 {convertTimestampToFormat(
//                                                     document?.document_expiry_date
//                                                 )}
//                                             </p>
//                                         )}
//                                     </div>
//                                 </div>
//                             )}

//                             {document?.document_approve && (
//                                 <div className="card mb-4" style={{ boxShadow: "unset" }}>
//                                     <div className="card-body p-3">
//                                         <p className="mb-0">
//                                             Approved by admin {" "}
//                                             <b>
//                                                 (ID: #{document?.document_approve.admin_user.admin_id},{" "}
//                                                 Name:{" "}
//                                                 {document?.document_approve.admin_user.admin_full_name})
//                                             </b>{" "}
//                                             at{" "}
//                                             {convertTimestampToFormat(
//                                                 document?.document_approve.document_check_check_at
//                                             )}
//                                         </p>
//                                     </div>
//                                 </div>
//                             )}

//                             <aside
//                                 style={{
//                                     ...styles.thumbsContainer,
//                                     justifyContent: window.innerWidth < 770 ? "center" : ""
//                                 }}
//                             >
//                                 {document?.document_files?.map((file) => (
//                                     <FileItem
//                                         file={file}
//                                     />
//                                 ))}
//                             </aside>
//                         </>
//                     )}
//                 </section>
//             }
//             footer={
//                 <div className="mt-3">
//                     <button
//                         className={`btn btn-icon btn-3 btn-${theme.close_btn} btn-sm me-2`}
//                         type="button"
//                         onClick={handleClose}
//                     >
//                         <span className="btn-inner--icon">
//                             <i className="material-icons text-lg">close</i>
//                         </span>
//                         <span className="btn-inner--text ms-1">Close</span>
//                     </button>
//                     {isHaveNewDocument && (
//                         <button
//                             className={`btn btn-icon btn-3 btn-${theme.main} btn-sm me-2`}
//                             type="button"
//                             onClick={isShowNew ? handleCurrentDocumentFiles : handleNewDocumentFiles}
//                         >
//                             <span className="btn-inner--icon">
//                                 <i className="material-icons text-lg">library_books</i>
//                             </span>
//                             <span className="btn-inner--text ms-1">{isShowNew ? "Current" : "New"} document</span>
//                         </button>
//                     )}
//                     <button
//                         className={`btn btn-icon btn-3 btn-warning btn-sm`}
//                         type="button"
//                         onClick={() => navigate(`/ftm/view/${ftmId}`)}
//                     >
//                         <span className="btn-inner--icon">
//                             <i className="material-icons text-lg">person</i>
//                         </span>
//                         <span className="btn-inner--text ms-1">Tradesperson</span>
//                     </button>
//                 </div>
//             }
//         />
//     );
// }

// export default DocumentFiles;

import { useEffect, useState, useCallback, memo } from "react";
import { useNavigate } from "react-router-dom";

import ModalTemplate from "../../../../components/modal/modalTemplate";
import DivSpinner from "../../../../components/divSpinner";
import { fetchDocument } from "../service";
import { convertTimestampToFormat } from "../../../../utils";
import styles from "../../../approvalProcess/components/styles";
import { theme } from "../../../../theme";
import ImagePreviewModal from "./ImagePreviewModal";

const IMAGE_EXTENSIONS = new Set([
    ".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"
]);

/* -------------------- File Item -------------------- */
const FileItem = memo(({ file, onPreview }) => {
    const filePath = file?.document_file_path ?? "";
    const fileName = filePath.split("/").pop()?.toLowerCase() ?? "";

    const isImage = [...IMAGE_EXTENSIONS].some(ext =>
        fileName.endsWith(ext)
    );

    return (
        <div
            style={{
                ...styles.thumb,
                cursor: isImage ? "pointer" : "default"
            }}
            onClick={() => isImage && onPreview(filePath)}
        >
            {isImage ? (
                <img
                    src={filePath}
                    alt="document"
                    style={styles.thumbImage}
                    loading="lazy"
                />
            ) : (
                <div style={styles.pdfPreview}>
                    <i className="material-icons" style={{ fontSize: 48 }}>
                        file_present
                    </i>
                </div>
            )}

            <p className="mt-2 mb-0" style={styles.fileName}>
                {convertTimestampToFormat(file.document_file_uploaded_at)}
            </p>
        </div>
    );
});

FileItem.displayName = "FileItem";

/* -------------------- Main Component -------------------- */
const DocumentFiles = ({
    show,
    handleClose,
    documentId,
    documentType,
    openNewDocumentFiles,
    openCurrentDocumentFiles,
    isHaveNewDocument,
    ftmId
}) => {
    const navigate = useNavigate();

    const [document, setDocument] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isShowNew, setIsShowNew] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    /* -------------------- Fetch Document -------------------- */
    useEffect(() => {
        if (!documentId) return;

        let isMounted = true;

        const getDocument = async () => {
            setLoading(true);
            setDocument(null);

            try {
                const response = await fetchDocument({
                    document_id: documentId,
                    document_type: documentType
                });

                if (isMounted && response?.status === "Success") {
                    setDocument(response.document);
                }
            } catch (error) {
                console.error("Failed to fetch document:", error);
            } finally {
                isMounted && setLoading(false);
            }
        };

        getDocument();

        return () => {
            isMounted = false;
        };
    }, [documentId, documentType]);

    /* -------------------- Handlers -------------------- */
    const handleToggleDocuments = useCallback(() => {
        setIsShowNew(prev => !prev);
        isShowNew ? openCurrentDocumentFiles() : openNewDocumentFiles();
    }, [isShowNew, openCurrentDocumentFiles, openNewDocumentFiles]);

    const handleNavigateFtm = useCallback(() => {
        if (ftmId) navigate(`/ftm/view/${ftmId}`);
    }, [ftmId, navigate]);

    const openImagePreview = useCallback((src) => {
        setPreviewImage(src);
    }, []);

    const closeImagePreview = useCallback(() => {
        setPreviewImage(null);
    }, []);


    /* -------------------- Render -------------------- */
    return (
        <ModalTemplate
            show={show}
            closeFun={handleClose}
            centered
            backdrop="static"
            title={
                !loading
                    ? document?.document_type?.document_type_name?.toUpperCase()
                    : null
            }
            body={
                <section>
                    {loading ? (
                        <div style={{ height: `${window.innerHeight - 387}px` }}>
                            <DivSpinner />
                        </div>
                    ) : (
                        <>
                            {/* -------------------- Comment & Expiry -------------------- */}
                            {(document?.document_comment || document?.document_expiry_date) && (
                                <div className="card mb-4" style={{ boxShadow: "unset" }}>
                                    <div className="card-body p-3">
                                        {document?.document_comment && (
                                            <p>
                                                <b>Comment:</b> {document.document_comment}
                                            </p>
                                        )}
                                        {document?.document_expiry_date && (
                                            <p className="mb-0">
                                                <b>Expiry date:</b>{" "}
                                                {convertTimestampToFormat(
                                                    document.document_expiry_date
                                                )}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* -------------------- Approval Info -------------------- */}
                            {document?.document_approve && (
                                <div className="card mb-4" style={{ boxShadow: "unset" }}>
                                    <div className="card-body p-3">
                                        <p className="mb-0">
                                            Approved by admin{" "}
                                            <b>
                                                (ID: #
                                                {document.document_approve.admin_user?.admin_id},{" "}
                                                Name:{" "}
                                                {
                                                    document.document_approve.admin_user
                                                        ?.admin_full_name
                                                })
                                            </b>{" "}
                                            at{" "}
                                            {convertTimestampToFormat(
                                                document.document_approve
                                                    .document_check_check_at
                                            )}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {/* -------------------- Files -------------------- */}
                            <aside
                                style={{
                                    ...styles.thumbsContainer,
                                    justifyContent: "center"
                                }}
                            >
                                {document?.document_files?.map(file => (
                                    <FileItem
                                        key={file.document_file_id}
                                        file={file}
                                        onPreview={openImagePreview}
                                    />
                                ))}
                            </aside>
                        </>
                    )}

                    <ImagePreviewModal
                        show={!!previewImage}
                        imageSrc={previewImage}
                        onClose={closeImagePreview}
                    />

                </section>
            }
            footer={
                <div className="mt-3">
                    <button
                        className={`btn btn-icon btn-3 btn-${theme.close_btn} btn-sm me-2`}
                        onClick={handleClose}
                    >
                        <i className="material-icons text-lg">close</i>
                        <span className="ms-1">Close</span>
                    </button>

                    {isHaveNewDocument && (
                        <button
                            className={`btn btn-icon btn-3 btn-${theme.main} btn-sm me-2`}
                            onClick={handleToggleDocuments}
                        >
                            <i className="material-icons text-lg">library_books</i>
                            <span className="ms-1">
                                {isShowNew ? "Current" : "New"} document
                            </span>
                        </button>
                    )}

                    <button
                        className="btn btn-icon btn-3 btn-warning btn-sm"
                        onClick={handleNavigateFtm}
                        disabled={!ftmId}
                    >
                        <i className="material-icons text-lg">person</i>
                        <span className="ms-1">Tradesperson</span>
                    </button>
                </div>
            }
        />
    );
};

export default DocumentFiles;